var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5195 9V16.88C10.56 17.18 10.4587 17.5 10.2257 17.71C9.83066 18.1 9.1925 18.1 8.79745 17.71L6.76144 15.7C6.52846 15.47 6.42716 15.16 6.46768 14.87V9H6.43729L0.60273 1.62C0.258329 1.19 0.339364 0.56 0.774931 0.22C0.96739 0.08 1.18011 0 1.40296 0H15.5842C15.807 0 16.0198 0.08 16.2122 0.22C16.6478 0.56 16.7288 1.19 16.3844 1.62L10.5498 9H10.5195Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNav);
export default __webpack_public_path__ + "static/media/filterNav.86b0207fb64a6c189a26f94ba269bd03.svg";
export { ForwardRef as ReactComponent };